'use strict';
import angular from 'angular';
import commentsTemplateHtmlUrl from '../../../views/directives/commentsTemplate.html';

angular.module('app.services')

        .service('$comments', ['$q', '$modal', function($q, $modal) {
            var myAlert;

            this.open = function(size, message){

                var deferred = $q.defer();

                var modalInstance = $modal.open({
                    animation: true,
                    templateUrl: commentsTemplateHtmlUrl,
                    controller: 'UserCommentsModalController',
                    size: 'lg',
                    resolve: {
                        message: function () {
                            return message;
                        }
                    }
                });

                modalInstance.result.then(function (commentObj) {
                    deferred.resolve(commentObj);
                }, function () {
                    //modal dismissed
                    deferred.reject();
                });

                return deferred.promise;
            };

            return this;

        }]);